import HomeScreen from "./pages/HomeScreen";

const App = () => {
  return <HomeScreen />;
};

export default App;
